import {NfMessage, NfMessageType} from "./NfMessage";

/**
 * Oznacza typ globalnych wiadomości od service workera, które mogą być wysyłane do wielu komponentów jednocześnie.
 * Komponenty muszą się zarejestrować, aby je otrzymywać
 */
export class NfGlobalMessage extends NfMessage {
    public constructor(type: NfMessageType, isNewMessage: boolean) {
        super(type);
        if(isNewMessage) {
            this.globalMessageVersion = NfGlobalMessage.nextGlobalMessageVersion++;
        }
    }

    public serviceInstanceId: number|null = null;
    public globalMessage = true;
    /**
     * Jeśli wiadomość ma być automatycznie ponawiana dla nowo zarejestrowanych komponentów, to ustaw to na true
     */
    public persistentMessage = false;
    /**
     * Jeśli jest podany tu id komponentu, to wiadomość nie zostanie przesłana z powrotem do tego komponentu
     */
    public sourceComponentId: number|null = null;
    private _globalMessageVersion: number = 1;
    /**
     * Używamy tego, żeby rozpoznać, że taką wiadomość już otrzymaliśmy wcześniej
     * To się przydaje podczas gdy service worker publikuje wielokrotnie globalne wiadomości dla nowo pojawiających się komponentów
     * Wtedy możemy zignorować stare wiadomości dzięki tej properce
     */
    public get globalMessageVersion(): number  {
        if(this._globalMessageVersion >= NfGlobalMessage.nextGlobalMessageVersion) {
            NfGlobalMessage.nextGlobalMessageVersion = this._globalMessageVersion + 1;
        }
        return this._globalMessageVersion;
    }
    protected set globalMessageVersion(value: number) {
        this._globalMessageVersion = value;
        if(value >= NfGlobalMessage.nextGlobalMessageVersion) {
            NfGlobalMessage.nextGlobalMessageVersion = value + 1;
        }
    }
    private static nextGlobalMessageVersion: number = 2;
    public static isSuperClassOf(message: NfMessage): message is NfGlobalMessage {
        //@ts-ignore
        return ('globalMessage' in message) && message['globalMessage'] === true;
    }
}